import { render } from "./TrainItem.vue?vue&type=template&id=707700bd&scoped=true"
import script from "./TrainItem.vue?vue&type=script&lang=js"
export * from "./TrainItem.vue?vue&type=script&lang=js"

import "./TrainItem.vue?vue&type=style&index=0&id=707700bd&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707700bd"]])

export default __exports__